import { updateComponentData } from "../../../../Utils/CommonBaseClass";

/**
 * Updates the 'customer-kyc-joint-owners-data' state in the component.
 *
 * @param dispatch The dispatch function from your state management (e.g., NgRx, custom dispatch).
 * @param newState The new partial or full state object for joint owners.
 */
export const updateCustomerKycJointOwnersData = (dispatch: any, newState: any) => {
    updateComponentData(dispatch, 'customer-kyc-joint-owners-data', newState);
};